import Vue from "vue";

import Vuetify from "vuetify";
import "vuetify/dist/vuetify.min.css";
import "./style/global.css";
import "./style/widget.css";
Vue.use(Vuetify);

import router from "./router/router.js";

import store from "./store/store.js";

import axios from "./axios/axios.js";
import VueAxios from "vue-axios";
Vue.use(VueAxios, axios);

import VueChartkick from "vue-chartkick";
import Chart from "chart.js";
Vue.use(VueChartkick, { adapter: Chart });

import "./filters/filters.js";

import Root from "./components/Root";


new Vue({
  el: "#app",
  router,
  store,
  render: (h) => h(Root)
});



// WEBPACK FOOTER //
// ./src/main.js